import { cn, Spinner } from '@1trading/react';

interface LoadingPanelProps {
  /** Padding overrides, e.g. 'py-6' for compact panels */
  className?: string;
  /** Screen-reader label; defaults to 'Loading' */
  label?: string;
}

/** Centered spinner while a dataset's first page loads (legacy BopLoadingPanel, promoted from the brokers slice). */
export const LoadingPanel = ({ className, label }: LoadingPanelProps) => (
  <div aria-label={label ?? 'Loading'} className={cn('flex items-center justify-center py-12', className)} role="status">
    <Spinner className="size-6" />
  </div>
);
LoadingPanel.displayName = 'LoadingPanel';
